import { render } from "./DetailRow.vue?vue&type=template&id=56c9766e"
import script from "./DetailRow.vue?vue&type=script&lang=js"
export * from "./DetailRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/PurchaseOrders/DetailRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56c9766e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56c9766e', __exports__)) {
    console.log('reload')
    api.reload('56c9766e', __exports__)
  }
  
  module.hot.accept("./DetailRow.vue?vue&type=template&id=56c9766e", () => {
    console.log('re-render')
    api.rerender('56c9766e', render)
  })

}


export default __exports__